module.exports = __webpack_public_path__ + "static/js/2.580a01a6.chunk.worker.js"